import { FC } from 'react';
import { Link, LinkProps } from '@chakra-ui/react';
export interface CbLinkProps extends LinkProps {
  renderAsButton?: boolean;
}
export const CbLink: FC<CbLinkProps> = ({
  as,
  children,
  href,
  renderAsButton = false,
  onClick,
  ...props
}) => {
  const getChakraLink = (isButton: boolean) => <Link as={isButton ? 'button' : undefined} color="text.primary" href={href ? href : undefined} onClick={onClick} {...props} data-sentry-element="Link" data-sentry-component="getChakraLink" data-sentry-source-file="CbLink.tsx">
      {children}
    </Link>;
  if (as) {
    return <Link as={as} href={href}>
        {getChakraLink(false)}
      </Link>;
  }
  return getChakraLink(renderAsButton);
};